export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_06.83aa1b9f.png";